import { DictRequestLinkingEntity } from '../../constants/banking';
import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import { DictRequestSnapshot } from '../../models/Banking';
import api from '../api';

const getDictRequest = (
    key: string,
    linkingEntity: DictRequestLinkingEntity,
    landlordId?: number
): Promise<DictRequestSnapshot> =>
    api.request<DictRequestSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/banking/dict_request`,
        params: decamelizeKeys({ landlordId, key, linkingEntity }),
    });

const createDictRequest = (
    key: string,
    linkingEntity: DictRequestLinkingEntity,
    landlordId?: number
): Promise<DictRequestSnapshot> =>
    api.request<DictRequestSnapshot>({
        action: 'BANKING_DICT_REQUEST',
        method: 'POST',
        url: `${getBackVersion()}/banking/dict_request`,
        params: decamelizeKeys({ landlordId, key, linkingEntity }),
    });

export { getDictRequest, createDictRequest };
